<template>
  <div>
    <el-dialog
      title="Видимость колонок"
      :visible.sync="show"
      width="300px"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      append-to-body
      :show-close="true"
    >

      <el-checkbox-group
        v-model="columns"
        @change="columnsChanged"
      >
        <el-checkbox
          v-for="(columnName, columnNameKey) in columnsList"
          :key="columnNameKey"
          style="display: block"
          :label="columnNameKey"
        >
          {{columnName}}
        </el-checkbox>
      </el-checkbox-group>


      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="show=false">Закрыть</el-button>
      </span>
    </el-dialog>

    <span ref="wrapper">
      <slot name="reference"></slot>
    </span>
  </div>
</template>

<script>

import { off, on } from "element-ui/src/utils/dom";

export default {
  name: "CascadingTreeColumnsVisibleEditModal",
  components: {  },


  data() {
    return {
      show: false,

      columnsKeyName: 'cascading_elements_tree_columns',
      columnsList: {
        'weight': 'Вес',
        'value': 'Значение',
        'scale_unit': 'Ед.изм. / Тип шкалы',
        'baseline': 'Базовое',
        'target': 'Целевое',
        'progress': 'Прогресс',
        'performance': 'Производительность',

        'scale': 'Шкала',
        'min': 'Минимальное',
        'max': 'Максимальное',
        'asfdfasfdas': 'Функция расчета',
        'card': 'Карта',
        'card_scale': 'Шкала карты',
        'card_weight': 'Вес в карте',
        'card_bonus': 'Результат карты',
        'responsible': 'Ответственный',
      },
      defaultColumns: ["weight", "value", "scale_unit", "baseline", "target", "progress"],
      columns: [],
    }
  },
  mounted() {
    if (this.$refs.wrapper.children) {
      on(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  beforeDestroy() {
    if (this.$refs.wrapper.children) {
      off(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  watch: {},
  methods: {
    getDefaultColumns(){
      return this.defaultColumns;
    },
    getCurrentColumns(){
      let columns = localStorage.getItem(this.columnsKeyName);
      if( columns === null) {
        columns = this.getDefaultColumns();
        localStorage.setItem(this.columnsKeyName, JSON.stringify(columns));
      } else {
        columns = JSON.parse(columns);
      }
      return columns;
    },

    showModal() {
      this.show = true;
      this.columns = this.getCurrentColumns();
    },

    columnsChanged(){
      localStorage.setItem(this.columnsKeyName, JSON.stringify(this.columns));
      this.$emit('change');
    },

  },


}
</script>